// extracted by css-extract-rspack-plugin
var _1 = "hIsMgwiv3j0HLnuFOQoDHg--";
var _2 = "aYWK81-w40qRX58itlQwKA--";
var _3 = "Nru33DBr7nanTluyNDCG2Q--";
var _4 = "m9G9RpNhwkLX4IrvLS3Yqw--";
var _5 = "_03ev-9NBevOLdTTH7zU-dA--";
var _6 = "rNE9gW0pqLwnRkbZHwbjeQ--";
export { _1 as "container", _2 as "description", _3 as "descriptionOutput", _4 as "label", _5 as "sharedTextArea", _6 as "textarea" }
